import { Button, DataSource, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderHistType extends Layout {
	buttonScreenClass: Button;
	sourceOrderHistType: DataSource;
	switchManualEntry: Switch;
	textboxDescr: Textbox;
	textboxId: Textbox;
	textboxRemarks: Textbox;
	textboxScreenClassName: Textbox;
}
